import { render, staticRenderFns } from "./PersonalFinance.vue?vue&type=template&id=2cc48ce8&"
import script from "./PersonalFinance.vue?vue&type=script&lang=js&"
export * from "./PersonalFinance.vue?vue&type=script&lang=js&"
import style0 from "./PersonalFinance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PersonalFinance.vue"
export default component.exports